export default "__VITE_ASSET__DTdbMmxT__"